import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

function valuetext(value: number) {
    switch (value) {
        case 0:
            return 'Least Waste';
        case 1:
            return 'Less Waste';
        case 2:
            return '-';
        case 3:
            return 'Less Stock Outs';
        case 4:
            return 'Least Stock Outs';
        default:
            return '-';
    }
}

export function IngredientSlider(props: any) {
    const handleChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number') {
            props.setArrayState(
                props.index,
                newValue,
                props.setSliders,
                props.sliders
            );
        }
    };
    return (
        <Box marginBottom="-10px" marginTop="-6px" sx={{ width: 200 }}>
            <Slider
                track={false}
                value={props.sliders[props.index]}
                aria-label="Ingredient"
                defaultValue={2}
                getAriaValueText={valuetext}
                valueLabelFormat={valuetext}
                valueLabelDisplay="auto"
                onChange={handleChange}
                sx={{ width: '200px' }}
                step={1}
                min={0}
                max={4}
                marks
            />
        </Box>
    );
}
